/*-----------------------------------------------------------------
- Special Sale
-----------------------------------------------------------------*/
export default {
    percent_mark : '٪',
    discount     : 'تخفیف',
    see_product  : 'مشاهده محصول',
    toman        : 'تومان',
    counter_title: 'زمان باقی مانده تا پایان پیشنهاد ویژه',
};
